import { FC, useState } from 'react';
import { LoginContext } from '../../../config/authentication/LoginContext';
import { useLoginData } from '../../../config/authentication/useLoginData';
import { LoginDialog } from './LoginDialog';
import { LoginDialogContext } from './LoginDialogContext';
import { LoginDialogCallback } from './LoginDialogState';

type Props = {
  children?: React.ReactElement;
};
/**Componente que contiene al modal de login y que permite
 * activar dicho modal a los demás componentes.
 */
export const LoginBoundary: FC<Props> = ({ children }) => {
  const loginData = useLoginData();
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const [afterLoginCallback, setAfterLoginCallback] = useState<LoginDialogCallback>();

  const loginDialogState = {
    showDialog: (callback?: LoginDialogCallback) => {
      setAfterLoginCallback(() => callback);
      setShowLogin(true);
    },
  };

  return (
    <LoginContext.Provider value={loginData}>
      <LoginDialog show={showLogin} onCancel={() => setShowLogin(false)} afterLogin={afterLoginCallback} />
      <LoginDialogContext.Provider value={loginDialogState}>{children}</LoginDialogContext.Provider>
    </LoginContext.Provider>
  );
};
